<script setup lang="ts">
import { useRoute } from 'vue-router'

import PartnerEnv from '@/components/features/partners/PartnerEnv.vue'
import CallHistory from '@/components/features/calls/CallHistory.vue'
import CallActions from '@/components/features/calls/CallActions.vue'
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import PartnerButtonRedirect from '@/components/common/buttons/PartnerButtonRedirect.vue'
import type { Contact } from '@/api-swagger'
import PartnerContactDetails from '@/components/features/partners/PartnerContactDetails.vue'
import Bs2Title from '@/components/common/layout/Bs2Title.vue'

const route = useRoute()
const partnerId = Array.isArray(route.params.partnerId)
  ? parseInt(route.params.partnerId[0])
  : parseInt(route.params.partnerId)
const contactId: number | undefined = route.query.contactId
  ? Number(route.query.contactId)
  : undefined

const partnerStore = usePartnerStore()
const { partner, childs } = storeToRefs(partnerStore)

const contact = ref<Contact | undefined>(undefined)

onMounted(async () => {
  await Promise.all([
    partnerStore.searchId(partnerId),
    partnerStore.getContactsByParentId(partnerId),
  ])

  if (childs.value) {
    contact.value = childs.value.find((child: Contact) => child.id === contactId)
  }
})
</script>

<template>
  <div class="flex flex-col pt-8 pl-8">
    <Bs2Title title="Fiche d'Appel Client" />
  </div>
  <div class="p-8 flex gap-4 items-start">
    <div class="flex flex-1 flex-col items-center w-auto bg-base-100 rounded-2xl gap-4 p-4 px-24">
      <div v-if="partner" class="flex justify-center items-start gap-10">
        <div class="flex-col justify-center gap-2">
          <PartnerButtonRedirect
            :partner-name="partner?.name"
            :partner-id="partner?.id"
            openNewTab
          ></PartnerButtonRedirect>
          <div v-if="contact"><span class="font-semibold">Contact :</span> {{ contact.name }}</div>
        </div>
        <CallActions :partner-id="partnerId" />
      </div>
      <div v-else class="skeleton opacity-30 h-[30px]"></div>
      <PartnerContactDetails />
      <CallHistory :partner-id="partnerId" class="" />
    </div>

    <PartnerEnv :partner-id="partnerId" />
  </div>
</template>
